/*
 |--------------------------------------------------------------------------
 | HTTP Request Service
 |--------------------------------------------------------------------------
 */

import axios from "axios";
import notificator from "@/services/notificator";

const http = axios.create({
  withCredentials: true
});

/**
 * Add interceptor
 */
http.interceptors.response.use(
  response => response,
  errorResponseHandler
);

/**
 * Create an error response handler
 *
 * @param {Error} error
 */
function errorResponseHandler(error) {

  // Find the message in the response
  const message = findMessage(error);
  const status = findStatus(error.response);

  // Show the message
  notificator.open({
    message: message,
    type: "danger"
  });

  // If auth error, redirect to login in 1.5 seconds
  if (status === 419 || status === 401) {
    setTimeout(() => {
      window.location.href = Laravel.route("login");
    }, 1000);
  }

  // Reject the Promise
  return Promise.reject(error);
}

export default http;

/*
|--------------------------------------------------------------------------
| Utils
|--------------------------------------------------------------------------
|
*/

/**
 * Find the message of an error
 *
 * @param {Error} error
 * @return {String} Error message
 */
function findMessage(error) {
  // Default message
  const defaultMessage = "Whoops! An error has occurred.";

  // No response returned, this may be a big error
  if (!_.isObject(error.response)) {
    return defaultMessage;
  }

  if (!_.isObject(error.response.data)) {
    return defaultMessage;
  }

  if (_.isString(error.response.data.message)) {
    return error.response.data.message;
  }

  if (_.isObject(error.response.data.errors) && _.isString(error.response.data.errors.message)) {
    return error.response.data.errors.message;
  }

  return defaultMessage;
}

/**
 * Find the status of a response
 *
 * @param {object} response
 */
function findStatus(response) {
  if (!_.isObject(response)) {
    return null;
  }

  return response.status;
}
